import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";
import { LONG_WRITE_TIMEOUT_MS } from "@/utils/axios-client";
import { OrderSheetTab } from "@/features/order-sheets/order-sheet.type";
import { OrderSheetRevision } from "@/features/order-sheet-sets/order-sheet-revision.type";
import { CompanyType } from "@/features/types";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";

export interface CreateOrderSheetRevisionRequest {
  orderSheetTabs: OrderSheetTab[];
}

export interface CreateOrderSheetRevisionResponse extends OrderSheetRevision {}

export interface CreateOrderSheetRevisionPathParameter {
  by: CompanyType;
  companyId: number;
  orderSheetSetId: number;
  orderSheetId: number;
}

export const createOrderSheetRevisionTemplateUrl = `/:by/:companyId/order-sheet-sets/:orderSheetSetId/order-sheets/:orderSheetId/revisions`;

export const createOrderSheetRevisionKey: YWRKey<CreateOrderSheetRevisionPathParameter> =
  {
    url: (parameter) => {
      return calcUrl(createOrderSheetRevisionTemplateUrl, parameter);
    },
    method: "post",
  };

export default function useCreateOrderSheetRevision() {
  const fetcher = useFetcher<
    CreateOrderSheetRevisionRequest,
    CreateOrderSheetRevisionResponse
  >();
  // 오더시트 저장은 탭·상품 수에 따라 30초를 넘길 수 있다 — 기본 타임아웃(30초)에 잘리지 않게.
  return useYWR(createOrderSheetRevisionKey, fetcher, {
    timeout: LONG_WRITE_TIMEOUT_MS,
  });
}
